import * as React from "react";
const SvgDirOpen = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 64", fill: "none", stroke: "currentColor", strokeWidth: 4, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M9,52l12-24h38l-12,24h-38v-36l5,-5h15l5,5h14v12" }));
export default SvgDirOpen;
